<template>
    <div class="card postition-relative" v-for="proveedor in localProveedores.proveedor" :key="proveedor">        
        <div class="card-header bg-gray" style="display: flex; justify-content: space-between;">
            <div style="display: flex; align-items: center; gap: 5px">
                <span>
                    <div class="marcado-check">
                        <input type="checkbox" v-model="proveedor.marcado"
                            :true-value="1" :false-value="0" @change="marcarProveedor(proveedor)"
                            @input="autosave = false" title="Marcar trabajo">
                    </div>
                </span>
                <h3 @click="(console.log('1'))" :title="proveedor.trabajos[0].datos.nombre_operario" class="card-title" v-if="proveedor.trabajos">
                        <span v-if="proveedor.trabajos[0].datos.nombre_operario.slice(0,20).includes('Proveedor ')">
                        </span>
                        <span v-else>
                            {{ $t('general.proveedor') }}
                        </span>
                    {{proveedor.trabajos[0].datos.nombre_operario.slice(0,20)}}</h3>
                <!-- <h3 :title="proveedor.Compañia.trabajos[0].datos.nombre_operario" class="card-title"
                    v-else-if="proveedor.Compañia"><i class="fas fa-list mr-2"></i>{{
                    $t('general.proveedor') }} {{proveedor.Compañia.trabajos[0].datos.nombre_operario.slice(0,20)}}</h3>
                <h3 :title="proveedor._.trabajos[0].datos.nombre_operario" class="card-title" v-else-if="proveedor._"><i
                        class="fas fa-list mr-2"></i>{{ $t('general.proveedor') }}
                    {{ proveedor._.trabajos[0].datos.nombre_operario.slice(0,20) }}</h3>-->
                <h3 @click="(console.log('2'))" :title="proveedor.proveedor.trabajos[0].datos.nombre_operario" class="card-title"
                    v-else-if="proveedor.proveedor">
                    <span v-if="proveedor.proveedor.trabajos[0].datos.nombre_operario.slice(0,20).includes('Proveedor ')">
                        </span>
                        <span v-else>
                            {{ $t('general.proveedor') }}
                        </span>
                    {{ proveedor.proveedor.trabajos[0].datos.nombre_operario.slice(0,20) }}</h3>
            </div>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" title="Subsanar todos proveedor" style="color:white;"
                    @click="subsanarTrabajos(proveedor)"><i class="fas fa-tools"></i>&nbsp;Subsanar</button>
                <button type="button" class="btn btn-tool" title="Revisar todos proveedor" style="color:white;"
                    @click="revisarTrabajos(proveedor)"><i class="fas fa-check-double"></i>&nbsp;Revisar</button>
                <button type="button" class="btn btn-tool" title="Marcar facturar proveedor" style="color:white;"
                    @click="facturarTrabajos(proveedor)"><i class="fas fa-file-invoice-dollar"></i>
                    &nbsp; {{no_factura == 1 ? 'Marcar registrar' : 'Marcar facturar'}}</button>
                <button type="button" class="btn btn-tool" title="Eliminar todos los trabajos del proveedor"
                    style="color:white;" @click="eliminarTrabajos(proveedor)"><i
                        class="fas fa-times"></i>&nbsp;Eliminar</button>
                <button type="button" class="btn btn-tool" title="Eliminar todos los trabajos del proveedor al cliente"
                    style="color:white;" @click="eliminarTrabajosCliente(proveedor)"><i
                        class="far fa-times-circle"></i>&nbsp;Eliminar
                    cliente</button>
                <button type="button" class="btn btn-tool" title="Eliminar todos los trabajos del proveedor al proveedor"
                    style="color:white;" @click="eliminarTrabajosOperario(proveedor)"><i
                        class="fas fa-times-circle"></i>&nbsp;Eliminar
                    proveedor</button>
                <span :title="$t('general.total') + ' ' + $t('general.a cliente')" class="badge bg-success mr-2">{{
                    proveedor.totales.cliente}}&euro;</span>
                <span :title="$t('general.total') + ' ' + $t('general.a proveedor')" class="badge bg-danger mr-2">
                    {{
                    formattedOperarioTotal(proveedor.totales.operario.base,Math.round(proveedor.totales.operario.base-proveedor.totales.operario.contado))
                    }}</span>
                <span :title="$t('general.rentabilidad')" class="badge bg-info  mr-2">{{
                    proveedor.totales.beneficio.porcentaje}}%</span>
                <button type="button" class="btn btn-tool" style="color:white" @click="toggleImportarPresupuesto()"
                    title="Importar trabajo presupuesto">
                    <i class="fas fa-plus-square mr-1"></i> Importar
                </button>
                <button type="button" class="btn btn-tool" style="color:white" @click="toggleComponent()"
                    :title="$t('general.nuevo trabajo')">
                    <i class="fas fa-plus-square mr-1"></i> {{ $t('general.nuevo trabajo') }}
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="maximize">
                    <i class="fas fa-expand"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                </button>
            </div>
        </div><!---->
        <div class="card-body">
            <div v-if="showComponent">
                <trabajosrealizadonuevo :id="id" :proveedor="getKeyByValue(localProveedores.proveedor,proveedor)"
                    :servicio="servicio" />
            </div>
            <div v-if="mostrarImportarPresupuesto">
                <TrabajosImportarPresupuesto :id="id" :proveedor="getKeyByValue(localProveedores.proveedor,proveedor)"
                    :servicio="servicio" @trabajos-importados="ocultarImportarPresupuesto" />
            </div>
            <div v-show="!ocultarcliente">
                <trabajosrealizadoconcepto @cambiorevisado="cambioRevisado" ref="conc1" @cambio="cambiado" v-for="totales in proveedor.trabajos" @trabajomarcado="trabajoMarcado"
                    :key="totales" :totales="totales" :id="id" :servicio="servicio" />
            </div>
            <!--
                       <div v-if="proveedor.Cliente" v-show="!ocultarcliente">
                <trabajosrealizadoconcepto ref="conc1" @cambio="cambiado" v-for="totales in proveedor.Cliente.trabajos"
                    :key="totales" :totales="totales" :id="id" :servicio="servicio" />
            </div>
            <div v-if="proveedor.Compañia" v-show="!ocultarcliente">
                <trabajosrealizadoconcepto ref="conc2" @cambio="cambiado" v-for="totales in proveedor.Compañia.trabajos"
                    :key="totales" :totales="totales" :id="id" :servicio="servicio" />
            </div>-->
            <!-- Renderizado de Perjudicados --><!---
            <div v-for="(perjudicado, index) in getPerjudicados(proveedor)" :key="index" v-show="!ocultarcliente">
                <trabajosrealizadoconcepto ref="conc3" @cambio="cambiado" v-for="totales in perjudicado.trabajos"
                    :key="totales" :totales="totales" :id="id" :servicio="servicio" />
                
            </div>

            <div v-if="proveedor._" v-show="!ocultarcliente">
                <div v-for="totales in proveedor._.trabajos" :key="totales.id" class="position-relative">
                    <trabajosrealizadoconcepto ref="conc4" @cambio="cambiado" :totales="totales" :id="id"
                        :servicio="servicio" />
                </div>
        </div>-->
            <div v-if="proveedor.proveedor" v-show="!ocultaroperario">
                <trabajosrealizadoconceptoOperario @cambiorevisado="cambioRevisado" ref="conc5" @cambio="cambiado" @trabajomarcado="trabajoMarcado"
                    v-for="totales in proveedor.proveedor.trabajos" :key="totales" :totales="totales" :id="id"
                    :servicio="servicio" />
            </div>

        </div>
        <div>
            <TrabajosRealizadosProveedorFooter ref="foot" :datos="proveedor" :actualizar="actualizartot" />
        </div>
    </div>

    <div class="card" v-for="proveedor in proveedoreslistaaux" :key="proveedor.nombre">
        <div class="card-header bg-gray">
            <h3  @click="(console.log('3'))" class="card-title" v-if="proveedor.nombre"><i class="fas fa-list mr-2"></i>{{ $t('general.proveedor') }}
                {{ proveedor.nombre }}</h3>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" style="color:white" @click="toggleComponent()"
                    :title="$t('general.nuevo trabajo')">
                    <i class="fas fa-plus-square mr-1"></i> {{ $t('general.nuevo trabajo') }}
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="maximize">
                    <i class="fas fa-expand"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                </button>
            </div>
        </div>
        <div class="card-body">
            <div v-if="showComponent">
                <trabajosrealizadonuevo :id="id" :proveedor="proveedor.id"  :vienede="'proveedorvacio'" :servicio="servicio" />
            </div>
        </div>
    </div>




</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import trabajosrealizadoconcepto from './TrabajoRealizadoConcepto.vue';
import trabajosrealizadoconceptoOperario from './TrabajoRealizadoConceptoOperario.vue';
import trabajosrealizadonuevo from './TrabajoRealizadoNuevoProveedor.vue';
import TrabajosImportarPresupuesto from './TrabajosImportarPresupuesto.vue';
import TrabajosRealizadosProveedorFooter from './TrabajosRealizadosProveedorFooter.vue';

export default ({
    props:[
        'id',
        'servicio',
        'recargar',
        'ocultarcliente', 
        'ocultaroperario',
        'totalrent',
        'totaloperario',
        'totalcliente',
        'mostrarfacturar',
        'operariosingular',
        'operarios',
        'proveedoreslista',
        'trabajosproveedores',        
        'actualizartotales',
    ],
    setup() {
        return;
    },
    components: {
        trabajosrealizadoconcepto,
        trabajosrealizadoconceptoOperario,
        trabajosrealizadonuevo,
        TrabajosImportarPresupuesto,
        TrabajosRealizadosProveedorFooter,
    },
    data() {
        return {
            no_factura: localStorage.getItem('no_factura'),
            montado:false,
            cambio: false,
            actualizartot:false,
            showComponent: true,
            mostrarImportarPresupuesto: false,
            localProveedores: [],
            totalescliente: '',
            totalesoperario: '',
            totalesrentabilidad: '',
            suma: [],
            cargar: false,
            proveedoreslistaaux:[]
        };
    },
    methods: {
        trabajoMarcado(idtrabajo, marcado){
            this.$emit('trabajomarcado', idtrabajo, marcado);  
        },
        marcarProveedor(proveedor, marcadotodos) {
            this.$emit('marcaproveedor', proveedor, proveedor.marcado);
            if(this.$refs.conc1){
                for(let ref of this.$refs.conc1){
                    ref.marcarOperario(proveedor, marcadotodos);
                }
            }
            if(this.$refs.conc5){
                for(let ref of this.$refs.conc5){
                    ref.marcarOperario(proveedor, marcadotodos);
                }
            }
        },
        toggleComponent() {
            this.showComponent = !this.showComponent;
        },
        cambiado(val) {
            this.cambio = val;
        },
        async subsanarTodosMarcados(ids, fecha){
            console.log('llega', ids);
            ids.forEach(trabajo => {
                setTimeout(() => {                                
                    if(this.$refs.conc1){
                        for(let ref of this.$refs.conc1){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }
                    if(this.$refs.conc2){
                        for(let ref of this.$refs.conc2){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }
                    if(this.$refs.conc3){
                        for(let ref of this.$refs.conc3){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }
                    if(this.$refs.conc4){
                        for(let ref of this.$refs.conc4){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }
                    if(this.$refs.conc5){
                        for(let ref of this.$refs.conc5){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }                                
                }, 1000);
            })                                  
            this.cargardatos;
        },
        async subsanarTrabajos(operario) {     
            const api = new PwgsApi();
            var trabajos = [];
            for (let i = 0; i < operario.trabajos.length; i++){                        
                trabajos.push(operario.trabajos[i].datos.idtrabajo_servicio);
            }
            if(operario.proveedor){
                for (let i = 0; i < operario.proveedor.trabajos.length; i++){
                    trabajos.push(operario.proveedor.trabajos[i].datos.idtrabajo_servicio);
                }
            }
            if (trabajos.length > 0) {
                try {
                    if (window.confirm('¿Quiere subsanar todos los trabajos del operario?')) {
                        await api.put('trabajos/' + this.$props.id + '/subsanar', { ids_trabajos: trabajos });
                        this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos guardados para subsanar', life: 2000 });
                        this.cargardatos;
                        setTimeout(() => {
                            for (let trabajo of trabajos) {
                                if (this.$refs.conc1) {
                                    for (let ref of this.$refs.conc1) {
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                                if (this.$refs.conc2) {
                                    for (let ref of this.$refs.conc2) {
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                                if (this.$refs.conc3) {
                                    for (let ref of this.$refs.conc3) {
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                                if (this.$refs.conc4) {
                                    for (let ref of this.$refs.conc4) {
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                                if (this.$refs.conc5) {
                                    for (let ref of this.$refs.conc5) {
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                            }
                        }, 1000);
                    }
                }
                catch (error) {
                    if (error == "Error: Token no válido") {
                        api.get('logout');
                        localStorage.removeItem('token');
                        this.$router.push('/login');
                    }
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }

        },
        cambioRevisado(trabajo, revisado){
            console.log('trabajosRevisar', this.localProveedores, trabajo, revisado);
            try{
                for(let proveedor of Object.entries(this.localProveedores.proveedor)){
                    if(proveedor[1].proveedor){
                        for(let totales of proveedor[1].proveedor.trabajos){
                            if(totales.datos.idtrabajo_servicio == trabajo){
                                console.log('encontrado');
                                totales.datos.visto_tramitador_trabajo = revisado;
                                return;
                            }
                        }
                    }
                    if(proveedor[1].trabajos){
                        for(let trabs of proveedor[1].trabajos){
                            if(trabs.datos.idtrabajo_servicio == trabajo){
                                trabs.datos.visto_tramitador_trabajo = revisado;
                                return;
                            }
                        }
                    }
                }
            }catch(e){
                console.error(e);
            }
            console.log('trabajosRevisar2', this.localProveedores, trabajo, revisado);
        },
        async revisarTrabajos(operario) {
            var todosmarcados = true;    
            let trabajos = [];        
            console.log('llega', operario);
            try{
                if(operario.proveedor){
                    for(let totales of operario.proveedor.trabajos){    
                        if(totales.datos.visto_tramitador_trabajo == ''){
                            console.log('llega1');
                            todosmarcados = false;
                        }
                    }
                }
                
                if(todosmarcados && operario.trabajos){
                    for(let trabs of operario.trabajos){
                        if(trabs.datos.visto_tramitador_trabajo == ''){
                            todosmarcados = false;
                        }
                    }
                }
            }catch(e){
                console.error(e);
            }
            console.log('llega2');
            for (let i = 0; i < operario.trabajos.length; i++) {
                trabajos.push(operario.trabajos[i].datos.idtrabajo_servicio);
            }
            if(operario.proveedor){
                for (let i = 0; i < operario.proveedor.trabajos.length; i++){
                    trabajos.push(operario.proveedor.trabajos[i].datos.idtrabajo_servicio);
                }
            }
            console.log('llega3');
            console.log('trabajosRevisar', trabajos);
            const api = new PwgsApi();
            var bien = false;
            var errores = '';
            if(todosmarcados){
                console.log('llega4');
                for(let trabajo of trabajos){
                    try{                        
                        bien = true;
                        this.cargardatos;
                        if(this.$refs.conc1){
                            for(let ref of this.$refs.conc1){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }
                        if(this.$refs.conc2){
                            for(let ref of this.$refs.conc2){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }
                        if(this.$refs.conc3){
                            for(let ref of this.$refs.conc3){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }
                        if(this.$refs.conc4){
                            for(let ref of this.$refs.conc4){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }
                        if(this.$refs.conc5){
                            console.log("refconc5");
                            console.log("\n");
                            for(let ref of this.$refs.conc5){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }                
                    }
                    catch (error) {
                        if (error == "Error: Token no válido") {
                            api.get('logout');
                            localStorage.removeItem('token');
                            this.$router.push('/login');
                        }
                        errores = error;
                    }            
                }
                if(bien){
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos quitados de revisar', life: 2000 });
                    if(operario.proveedor){
                        for(let totales of operario.trabajos){    
                            if(totales.opciones.bloqueos.visto==0 && totales.datos.trabajo_duplicado != 1){
                                totales.datos.visto_tramitador_trabajo = '';
                            }
                        }
                    }
                    
                    if(todosmarcados && operario.trabajos){
                        for(let trabs of operario.trabajos){
                            if(trabs.opciones.bloqueos.visto==0 && trabs.datos.trabajo_duplicado != 1){
                                trabs.datos.visto_tramitador_trabajo = '';
                            }
                        }
                    }
                }     
                else{
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: errores, life: 5000 });
                }
            }else{
                console.log('llega5');
                for(let trabajo of trabajos){
                    try{
                        bien = true;
                        this.cargardatos;
                        if(this.$refs.conc1){
                            for(let ref of this.$refs.conc1){
                                ref.guardarrevisado(trabajo, false, true);
                            }
                        }
                        if(this.$refs.conc2){
                            for(let ref of this.$refs.conc2){
                                ref.guardarrevisado(trabajo, false, true);
                            }
                        }
                        if(this.$refs.conc3){
                            for(let ref of this.$refs.conc3){
                                ref.guardarrevisado(trabajo, false, true);
                            }
                        }
                        if(this.$refs.conc4){
                            for(let ref of this.$refs.conc4){
                                ref.guardarrevisado(trabajo, false, true);
                            }
                        }
                        if(this.$refs.conc5){
                            console.log("refconc5");
                            console.log("\n");
                            for(let ref of this.$refs.conc5){
                                ref.guardarrevisado(trabajo, false);
                            }
                        }                
                    }
                    catch (error) {
                        if (error == "Error: Token no válido") {
                            api.get('logout');
                            localStorage.removeItem('token');
                            this.$router.push('/login');
                        }
                        errores = error;
                    }            
                }
                if(bien){
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos guardados para revisar', life: 2000 });
                    if(operario.proveedor){
                        for(let totales of operario.trabajos){    
                            if(totales.opciones.bloqueos.visto==0 && totales.datos.trabajo_duplicado != 1){
                                totales.datos.visto_tramitador_trabajo = 'SI';
                            }
                        }
                    }
                    
                    if(todosmarcados && operario.trabajos){
                        for(let trabs of operario.trabajos){
                            if(trabs.opciones.bloqueos.visto==0 && trabs.datos.trabajo_duplicado != 1){
                                trabs.datos.visto_tramitador_trabajo = 'SI';
                            }
                        }
                    }
                }     
                else{
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: errores, life: 5000 });
                }
            }
        },
        async facturarTrabajos(operario) {
            let trabajos = [];
            for (let i = 0; i < operario.trabajos.length; i++) {
                trabajos.push(operario.trabajos[i].datos.idtrabajo_servicio);
            }
            let subidadatos = { ids_trabajos: trabajos };
            const api = new PwgsApi();
            try {
                await api.put('trabajos/' + this.$props.id + '/facturar-varios', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos guardados para facturar', life: 2000 });
                this.cargardatos;
                for (let trabajo of trabajos) {
                    if (this.$refs.conc1) {
                        for (let ref of this.$refs.conc1) {
                            ref.guardarfacturar(trabajo, false);
                        }
                    }
                    if (this.$refs.conc2) {
                        for (let ref of this.$refs.conc2) {
                            ref.guardarfacturar(trabajo, false);
                        }
                    }
                    if (this.$refs.conc3) {
                        for (let ref of this.$refs.conc3) {
                            ref.guardarfacturar(trabajo, false);
                        }
                    }
                    if (this.$refs.conc4) {
                        for (let ref of this.$refs.conc4) {
                            ref.guardarfacturar(trabajo, false);
                        }
                    }
                }
            }
            catch (error) {
                if (error == "Error: Token no válido") {
                    api.get('logout');
                    localStorage.removeItem('token');
                    this.$router.push('/login');
                }
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }

        },
        async eliminarTrabajos(operario) {
            let trabajos = [];
            for(let datos of Object.entries(operario)){
                if(datos[0] !='totales'){
                    if(datos[0] == 'trabajos'){
                        for (let i = 0; i < datos[1].length; i++){
                            trabajos.push(datos[1][i].datos.idtrabajo_servicio);
                        }
                    }else{
                        for (let i = 0; i < datos[1].trabajos.length; i++){
                            trabajos.push(datos[1].trabajos[i].datos.idtrabajo_servicio);
                        }
                    }
                }
            }
            if (window.confirm('¿Quiere eliminar todos los trabajos del operario?')) {
                for (let trabajo of trabajos) {
                    if (this.$refs.conc1) {
                        for (let ref of this.$refs.conc1) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc2) {
                        for (let ref of this.$refs.conc2) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc3) {
                        for (let ref of this.$refs.conc3) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc4) {
                        for (let ref of this.$refs.conc4) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc5) {
                        for (let ref of this.$refs.conc5) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                }
            }
        },
        async eliminarTrabajosCliente(operario) {
            let trabajos = [];
            for(let datos of Object.entries(operario)){
                if(datos[0] != 'operario' && datos[0] !='totales'){
                    if(datos[0] == 'trabajos'){
                        for (let i = 0; i < datos[1].length; i++){
                            trabajos.push(datos[1][i].datos.idtrabajo_servicio);
                        }
                    }else{
                        for (let i = 0; i < datos[1].trabajos.length; i++){
                            trabajos.push(datos[1].trabajos[i].datos.idtrabajo_servicio);
                        }
                    }
                }
            }
            if (window.confirm('¿Quiere eliminar todos los trabajos a clientes del operario?')) {
                for (let trabajo of trabajos) {
                    if (this.$refs.conc1) {
                        for (let ref of this.$refs.conc1) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc2) {
                        for (let ref of this.$refs.conc2) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc3) {
                        for (let ref of this.$refs.conc3) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc4) {
                        for (let ref of this.$refs.conc4) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc5) {
                        for (let ref of this.$refs.conc5) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                }
            }
        },
        async eliminarTrabajosOperario(operario) {
            let trabajos = [];
            for(let datos of Object.entries(operario)){
                if(datos[0] == 'proveedor'){
                    for (let i = 0; i < datos[1].trabajos.length; i++){
                        trabajos.push(datos[1].trabajos[i].datos.idtrabajo_servicio);
                    }
                }
            }
            if (window.confirm('¿Quiere eliminar todos los trabajos a proveedores del operario?')) {
                for (let trabajo of trabajos) {
                    if (this.$refs.conc1) {
                        for (let ref of this.$refs.conc1) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc2) {
                        for (let ref of this.$refs.conc2) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc3) {
                        for (let ref of this.$refs.conc3) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc4) {
                        for (let ref of this.$refs.conc4) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if (this.$refs.conc5) {
                        for (let ref of this.$refs.conc5) {
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                }
            }
        },
        toggleImportarPresupuesto() {
            this.mostrarImportarPresupuesto = !this.mostrarImportarPresupuesto;
        },
        ocultarImportarPresupuesto() {
            this.mostrarImportarPresupuesto = false; // Ocultar el callout de importar
            this.$toast.add({ severity: 'success', summary: this.$t('general.guardado'), detail: this.$t('general.datosguardadoscorrectamente'), life: 2000 });
            this.cargardatos(); // Volver a cargar los datos del componente padre
        },
        formattedOperarioTotal(base, contado) {
            let baseFormatted = `${base}€`;
            if (contado !== 0) {
                baseFormatted += ` (A proveedor ${contado}€)`;
            }
            return baseFormatted;
        },
        async cargardatos(nuevo, operario, tipotr, cantidad) { 
            console.log('nuevotr', nuevo, operario, tipotr, cantidad);
        //GET  modulos/pwgsapi/index.php/trabajos/:id_servicio/trabajos-servicio
            const api = new PwgsApi();
            if(nuevo){
                var opersnuevo = await api.get('trabajos/' + this.id + '/trabajos-servicio');
                console.log('lleganuevo', operario, this.localProveedores ,opersnuevo, tipotr);
                if(tipotr == 'cliente'){
                    for(let i = cantidad; i > 0; i--){
                        if(!this.localProveedores.proveedor[operario].trabajos){
                            this.localProveedores.proveedor[operario].trabajos = [];
                        }
                        this.localProveedores.proveedor[operario].trabajos.push(opersnuevo.proveedor[operario].trabajos[this.localProveedores.proveedor[operario].trabajos.length]);
                    }
                }else{
                    if(!this.localProveedores.proveedor[operario].proveedor){
                        this.localProveedores.proveedor[operario].proveedor = {trabajos: []};
                    }
                    for(let i = cantidad; i > 0; i--){
                    this.localProveedores.proveedor[operario].proveedor.trabajos.push(opersnuevo.proveedor[operario].proveedor.trabajos[this.localProveedores.proveedor[operario].proveedor.trabajos.length]);
                    }
                }
            }else{
                this.localProveedores = await api.get('trabajos/' + this.$props.id + '/trabajos-servicio');      
            }
            console.log("localProveedores", this.localProveedores);      
            Object.values(this.localProveedores.proveedor).forEach(proveedor => {
              /*  if(proveedor.Cliente){
                    var nombre1 = proveedor.Cliente.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    proveedor.Cliente.trabajos[0].datos.nombre_operario = nombre1;
                }else if(proveedor.Compañia){
                    var nombre = proveedor.Compañia.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    proveedor.Compañia.trabajos[0].datos.nombre_operario = nombre;
                }else if(proveedor._){
                    var nombre2 = proveedor._.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    proveedor._.trabajos[0].datos.nombre_operario = nombre2;
                }*/
               if(proveedor.proveedor){
                    var nombre3 = proveedor.proveedor.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    proveedor.proveedor.trabajos[0].datos.nombre_operario = nombre3;
               }
                else{
                    var nombre1 = proveedor.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    proveedor.trabajos[0].datos.nombre_operario = nombre1;
                }
            })
            //alert("Cargados desde proveedores");
            this.totalesrentabilidad = this.$props.totalcliente - this.$props.totaloperario;
            this.totalesrentabilidad = Math.round((this.totalesrentabilidad * 100).toFixed(2) / this.$props.totalcliente) + "%";
        },
        async cargarproveedoresaux(motivo) {
            console.log('entraaux', motivo);
            if(this.montado){
                this.proveedoreslistaaux = [];
                const api = new PwgsApi();
                let trabajosproveedoresaux = '';
                let aux = await api.get('servicios/' + this.$props.id + '/pedidos');
                var auxopers = await api.get('trabajos/' + this.id + '/trabajos-servicio');
                if (auxopers.proveedor) {
                    trabajosproveedoresaux = Object.keys(auxopers.proveedor);
                }
                for (let i = 0; i < aux.datos.length; i++) {
                    let repetido = false
                    for (let j = 0; j < trabajosproveedoresaux.length; j++) {
                        if (aux.datos[i].proveedores_idproveedor == trabajosproveedoresaux[j]) {
                            repetido = true;
                        }
    
                    }
                    if (repetido == false) {
                        let subidadatos = { id: aux.datos[i].proveedores_idproveedor, nombre: aux.datos[i].nombre_proveedor }
                        if(!this.proveedoreslistaaux.includes(subidadatos)){
                            this.proveedoreslistaaux.push(subidadatos);
                        }
                    }
                }
            }
            const uniqueArray = this.proveedoreslistaaux.filter((value, index) => {
            const _value = JSON.stringify(value);
            return index === this.proveedoreslistaaux.findIndex(obj => {
                return JSON.stringify(obj) === _value;
            });
                        });
            this.proveedoreslistaaux = uniqueArray;
            console.log("proveedoreslistaaux", this.proveedoreslistaaux);
            
        },
        getKeyByValue(object, value) {
            return Object.keys(object).find(key => object[key] === value);
        },
        togglecargar() { 
            this.cargar = !this.cargar;
        },
        getPerjudicados(operario) {
            if (!operario || typeof operario !== 'object' || Object.keys(operario).length === 0) {
                return [];
            }
            return Object.keys(operario)
                .filter(key => key.startsWith('Perjudicado_'))
                .map(key => operario[key]);
        },
        actualiztotales(id, resultados, baremo, idtrabajo, eliminar, tipo, confirma){
            console.log('resultados', resultados, id);
            var indice = Object.keys(resultados.proveedor).indexOf(id);
            this.$refs.foot[indice].actualizatotales(id, resultados);
            if(baremo || confirma){
                var index = -1;
                if(tipo != 'opera'){
                    for(let trabajo of Object.entries(resultados.proveedor[id].trabajos)){
                        if(trabajo[1].datos.idtrabajo_servicio == idtrabajo){
                            index = trabajo[0];
                        }
                    }
                    if(index != -1){
                        this.localProveedores.proveedor[id].trabajos[index] = resultados.proveedor[id].trabajos[index];
                    }
                }else{
                    for(let trabajo of Object.entries(resultados.proveedor[id].proveedor.trabajos)){
                        if(trabajo[1].datos.idtrabajo_servicio == idtrabajo){
                            index = trabajo[0];
                        }
                    }
                    if(index != -1){
                        this.localProveedores.proveedor[id].proveedor.trabajos[index] = resultados.proveedor[id].proveedor.trabajos[index];
                    }
                }

                if(this.localProveedores.proveedor[id].proveedor == undefined && resultados.proveedor[id].proveedor != undefined && resultados.proveedor[id].proveedor.trabajos.length > 0){
                    this.localProveedores.proveedor[id].proveedor = resultados.proveedor[id].proveedor;
                }else if(this.localProveedores.proveedor[id].proveedor.trabajos.length != resultados.proveedor[id].proveedor.trabajos.length){
                    this.localProveedores.proveedor[id].proveedor.trabajos.push(resultados.proveedor[id].proveedor.trabajos[resultados.proveedor[id].proveedor.trabajos.length - 1]);
                }
                if(this.localProveedores.proveedor[id].trabajos == undefined && resultados.proveedor[id].trabajos != undefined && resultados.proveedor[id].trabajos.length > 0){
                    this.localProveedores.proveedor[id].trabajos = resultados.proveedor[id].trabajos;
                }else if(this.localProveedores.proveedor[id].trabajos.length != resultados.proveedor[id].trabajos.length){
                    this.localProveedores.proveedor[id].trabajos.push(resultados.proveedor[id].trabajos[resultados.proveedor[id].trabajos.length - 1]);
                }
            }
            if(eliminar){
                var index2 = -1;
                if(tipo == 'cliente'){
                    if(this.localProveedores.proveedor[id].trabajos.length == 1){
                        delete this.localProveedores.proveedor[id].trabajos;
                    }else{
                        for(let trabajo of Object.entries(this.localProveedores.proveedor[id].trabajos)){
                            if(trabajo[1].datos.idtrabajo_servicio == idtrabajo){
                                index2 = trabajo[0];
                            }
                        }
                        if(index2 != -1){
                            this.localProveedores.proveedor[id].trabajos.splice(index2, 1);
                        }
                    }
                }else{
                    console.log('entraoperaelimno');
                    if(this.localProveedores.proveedor[id].proveedor.trabajos.length == 1){
                        delete this.localProveedores.proveedor[id].proveedor;
                    }else{
                        for(let trabajo of Object.entries(this.localProveedores.proveedor[id].proveedor.trabajos)){
                            if(trabajo[1].datos.idtrabajo_servicio == idtrabajo){
                                index2 = trabajo[0];
                            }
                        }
                        if(index2 != -1){
                            this.localProveedores.proveedor[id].proveedor.trabajos.splice(index2, 1);
                        }
                    }
                }
            }
            this.localProveedores.proveedor[id].totales = resultados.proveedor[id].totales;
        },
        vaciarOperarios(){
            this.localProveedores = {};
        },
    },
    activated(){
        console.log('activado');
        this.cargarproveedoresaux('mount');
    },
    mounted() {
        if (this.operariosingular) {
            // Si 'operariosingular' es verdadero, cargamos los datos nosotros mismos
            this.cargardatos();
        } else if (this.operarios && Object.keys(this.operarios).length > 0) {
            // Si 'operarios' está disponible y 'operariosingular' es falso o indefinido, usamos los datos del padre
            console.log('operariosmount', this.operarios);
            this.localProveedores = JSON.parse(JSON.stringify(this.operarios));
            this.montado = true;
            this.cargarproveedoresaux('mount');
            // if (this.localProveedores.proveedor)
            // {
            //     Object.values(this.localProveedores.proveedor).forEach(proveedor => {
            //     if(proveedor.Cliente){
            //         var nombre1 = proveedor.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
            //         proveedor.trabajos[0].datos.nombre_operario = nombre1;
            //     }else if(proveedor.Compañia){
            //         var nombre = proveedor.Compañia.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
            //         proveedor.Compañia.trabajos[0].datos.nombre_operario = nombre;
            //     }else if(proveedor._){
            //         var nombre2 = proveedor._.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
            //         proveedor._.trabajos[0].datos.nombre_operario = nombre2;
            //         }
            //        console.log('llega1', proveedor);
            //         if (proveedor.operario) {
            //         var nombre3 = proveedor.operario.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
            //         proveedor.operario.trabajos[0].datos.nombre_operario = nombre3;
            //     }
            //     else{
            //         console.log('llega2');
            //      if(proveedor.trabajos){   var nombre13 = proveedor.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
            //          proveedor.trabajos[0].datos.nombre_operario = nombre13;
            //      }
            //     }
            //     })
            // }
        }
    },
    watch: {
        actualizartotales(){
            this.actualizartot = !this.actualizartot;
        },
        id() { 
            this.cargarproveedoresaux('id');
            this.localProveedores = [];
            this.cargardatos();
        },
        cargar() { 
            //this.cargardatos();
        },
        cargado() {
            this.cargarproveedoresaux('cargado');
        },
        recargar() {
            this.cargarproveedoresaux('recargar');

            //this.cargardatos();
        },
        operariosingular(newVal) {            
            if (newVal) {
                // Si 'operariosingular' cambia a verdadero, cargamos los datos nosotros mismos
                this.cargardatos();
            } else {
                // Si 'operariosingular' cambia a falso, usamos los datos del padre si están disponibles
                if (this.operarios && Object.keys(this.operarios).length > 0) {
                    console.log("newvalprovsprov2", this.operarios, newVal);
                    this.localProveedores = JSON.parse(JSON.stringify(this.operarios));
                    // Object.values(this.localProveedores.proveedor).forEach(proveedor => {
                    //     if(proveedor.Cliente){
                    //         var nombre1 = proveedor.Cliente.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    //         proveedor.Cliente.trabajos[0].datos.nombre_operario = nombre1;
                    //     }else if(proveedor.Compañia){
                    //         var nombre = proveedor.Compañia.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    //         proveedor.Compañia.trabajos[0].datos.nombre_operario = nombre;
                    //     }else if(proveedor._){
                    //         var nombre2 = proveedor._.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    //         proveedor._.trabajos[0].datos.nombre_operario = nombre2;
                    //     }if (proveedor.trabajos) {
                    //         var nombre13= proveedor.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    //         proveedor.trabajos[0].datos.nombre_operario = nombre13;
                    //     }
                    //    else if (proveedor.operario) {
                    //         var nombre3 = proveedor.operario.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                    //         proveedor.operario.trabajos[0].datos.nombre_operario = nombre3;
                    //     }
                    // })
                }
            }
        },
        operarios(newVal) {
            console.log('llegacambioper', newVal);
            if (newVal && Object.keys(newVal).length > 0) {
                // Si 'operarios' cambia y 'operariosingular' es falso, actualizamos 'localOperarios'
                this.localProveedores = JSON.parse(JSON.stringify(newVal));                
                console.log("newvalprovsprov", newVal, this.operarios);
                // Object.values(this.localProveedores.proveedor).forEach(proveedor => {
                //     if(proveedor.Cliente){
                //         var nombre1 = proveedor.Cliente.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                //         proveedor.Cliente.trabajos[0].datos.nombre_operario = nombre1;
                //     }else if(proveedor.Compañia){
                //         var nombre = proveedor.Compañia.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                //         proveedor.Compañia.trabajos[0].datos.nombre_operario = nombre;
                //     }else if(proveedor._){
                //         var nombre2 = proveedor._.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                //         proveedor._.trabajos[0].datos.nombre_operario = nombre2;
                //     }
                //     if (proveedor.trabajos) {
                //         var nombre13 = proveedor.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                //         proveedor.trabajos[0].datos.nombre_operario = nombre13;
                //     }
                //    else if (proveedor.operario) {
                //         var nombre3 = proveedor.operario.trabajos[0].datos.nombre_operario.replace('Proveedor ', '');
                //         proveedor.operario.trabajos[0].datos.nombre_operario = nombre3;
                //     }
                // })
            }
        },
    }
})
</script>
<style scoped>
.marcado-check input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>